/**
 * "Don't show this again" for the "How should we help?" dialog on arrival (TMMAPP-0120 item 4): per
 * person, on this browser only. Storage can be unavailable (a private window, blocked site data),
 * so every read and write is guarded; an unreadable value means "show it", like `tmm_theme_mode`.
 */
const PREFIX = 'tmm_help_dialog_hidden:';

export function readHowWeHelpHidden(userId: number | null): boolean {
  if (userId === null) return false;
  try {
    return window.localStorage.getItem(`${PREFIX}${userId}`) === '1';
  } catch {
    return false;
  }
}

export function writeHowWeHelpHidden(userId: number | null): void {
  if (userId === null) return;
  try {
    window.localStorage.setItem(`${PREFIX}${userId}`, '1');
  } catch {
    // Storage unavailable: the dialog opens again next time, which is the safe default.
  }
}

/** Forget "Don't show this again" (Start over, TMMAPP-0119 §E 26c): the dialog opens again. */
export function clearHowWeHelpHidden(userId: number | null): void {
  if (userId === null) return;
  try {
    window.localStorage.removeItem(`${PREFIX}${userId}`);
  } catch {
    // Storage unavailable: nothing was remembered to clear.
  }
}
